import {SketchTrimMode} from '../SketchTrimTypes';
import type {SketchTrimController} from '../SketchTrimController';
import {SketchTrimInsideOutsideModeService} from './SketchTrimInsideOutsideModeService';

/**
 * 在外剪除模式服务。
 *
 * 该类只声明模式身份与显示文案，双边界选择状态机由公共父类统一维护。
 */
export class SketchTrimAwayOutsideModeService extends SketchTrimInsideOutsideModeService {
    /**
     * 构造在外剪除模式服务。
     *
     * @param controller 剪裁控制器。
     */
    public constructor(controller: SketchTrimController) {
        super(
            controller,
            SketchTrimMode.TrimAwayOutside,
            '在外剪除（Trim Away Outside）',
        );
    }
}
